import { Wallet } from '@/core/services/Wallets/WalletInterface'

export function getSymbolsHierarchy(wallets: Wallet[]): string[] {
  const result: string[] = []

  function traverseWallet(wallet: Wallet): void {
    result.push(wallet.symbol) // Добавляем текущий символ
    if (wallet.parents) {
      wallet.parents.forEach(({ wallet: parentWallet }: { wallet: Wallet }) => {
        traverseWallet(parentWallet) // Рекурсивно обрабатываем родителей
      })
    }
  }

  wallets.forEach(wallet => traverseWallet(wallet))

  return result
}
